/*
Vue components that are called when cart is open. First populate the cart with favorites
from ajax call (admin-ajax.php?action=get_favorites) with initFavorites() funtion. 
Then build and listen the "star" button that add item in cart lists with initComponentAddToCart().
*/
import { getParameterByName, createCookie, readCookie } from './util';

var sha256 = require('js-sha256');


const initCartElements = function initCartElements()
{
  const prefillFavorites = getParameterByName('favorites');

  if( prefillFavorites !== null ) {
    let favorites = prefillFavorites.split(',');

    _log("adding favorites");

    var data = {
      action: 'add_favorites',
      locale : locale,
      products: favorites,
      t : Date.now()
    };

    $.post(xhrUrl, data, (response) => {
      if (response && response.status === "ok") {
        createCookie('myaccountfavorites',true,1);
      }        
    });
  }

  initComponentAddToCart();
  initFavorites();
}


function initFavorites()
{
  if (!document.getElementById("go-cart")) {
    return false;
  } else {
    _log("initCart...");
  }



  new Vue(
    {
      el: "#go-cart",
      delimiters: ['[[',']]'],
      data: { items : null, myaccount : false },
      filters :
      {
        joinArray : function(array)
        {
          if (typeof array === "object" && array !== null) {
            return array.join(", ");
          } else {
            return "";
          }
        }
      },
      computed: {
        getMyAccountUrl : function () {
          if(this.items) {
            return `${myAccountUrl}/favorites?save=${this.items.map(e => e.ref_number)}`;
          }
        }
      },
      methods :
      {
        getFavorites : function ()
        {
          var data = {
            action: 'get_favorites',
            locale : locale,
            t : Date.now()
          };

          $.get(xhrUrl, data, this.getCart__callback);
        },

        getCart__callback : function (response)
        {
          if (typeof response === "object" && response.cartItems.length) {
            this.items = response.cartItems;
          } else {
            this.items = null;
          }

          eventBus.$emit('favorites-changed');
        },

        makeToken : function(time) {
            return sha256('go_'+time);
        },

        mt : function(time, pid) {
            return sha256('go_'+time+pid);
        },

        removeFromCart : function(product_id)
        {
          const t = Date.now();
          // _log("remove from cart");
          // _log(product_id);
          var data = {
            action : 'add_or_remove',
            product_id: product_id,
            isAdded : 1,
            t : t,
            csfr : this.mt(t, product_id),
          };

          $.post(xhrUrl, data, this.removeFromCart__callback);
        },

        removeFromCart__callback : function(response)
        {
          // _log("response");
          // _log(response);
          if (response && typeof response === "object" && response.status === "removed") {
            this.getFavorites();
          }

        },

      },
      created : function()
      {
        const myaccountCookie = readCookie('myaccountfavorites');

        this.myaccount = myaccountCookie === 'true';
      
        this.getFavorites();
      },
    });
}


function initComponentAddToCart()
{
  // _log("initComponentAddToCart");
  // _log($(".like-container").length);
  if (!$(".like-container").length) {
    // _log("false");
    return false;
  }

  Vue.component('addtocart-component',
    {
      template:
        `<button type="button" :id="'pid-'+product_id" class="add-watch-btn" @click="addToCart">
              <span class="d-none">{{ label }}</span>
              <span class=" watch-status" :class="watchStatus">
                  <span class="fa-icon black no w28 prt2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM405.8 317.9l27.8 162L288 403.5 142.5 480l27.8-162L52.5 203.1l162.7-23.6L288 32l72.8 147.5 162.7 23.6-117.7 114.8z"/></svg></span>
                  <span class="fa-icon black yes w28 prt2"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg></span>
              </span>
          </button>`,
      props:
      {
        product_id: String,
        label : String
      },

      data: function(){
        return {
          isAdded: false,
          wasChecked: false,
        }
      },


      computed : {
        watchStatus : function()
        {
          return (this.isAdded) ? "is-added" : "not-added";
        }
      }, // close computed

      methods:
      {
        isInViewport : function ()
        {
          let element = document.getElementById("pid-"+this.product_id);

          if (element) {
            const rect = element.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
           );
          } else {
            return false;
          }

        },

        initCheckStatus : function()
        {
          if (this.isInViewport()) {
            this.checkStatus();
          } else {
            this.initWindowScrollEvent();
          }
        },

        checkStatus : function ()
        {
          if (this.isInViewport() && !this.wasChecked) {
            this.wasChecked = true;
            window.removeEventListener('scroll', this.checkStatus);
            this.isWatchInCart();
          }
        },

        initWindowScrollEvent : function ()
        {
          // _^'log("initWindowScrollEvent: "+this.product_id);
          window.addEventListener('scroll', this.checkStatus);
        },

        isWatchInCart : function ()
        {
          let d = new Date();
          let t = d.getTime();
          var data = {
            action: 'is_in_cart',
            product_id: this.product_id,
            t : t+"_"+this.product_id
          };

          $.get(xhrUrl, data, this.addToCart__callback);
        },

        mt : function(time, pid) {
            return sha256('go_'+time+pid);
        },

        addToCart : function()
        {
          const t = Date.now();

          var data = {
            action: 'add_or_remove',
            product_id: this.product_id,
            t : t,
            csfr : this.mt(t, this.product_id),
            isAdded : (this.isAdded) ? 1 : 0
          };

          $.post(xhrUrl, data, this.addToCart__callback);
        },

        addToCart__callback : function (response)
        {
          if (response && typeof response === "object") {
            this.isAdded = (response.status === "added") ? true : false;

            go_header.cart_count_items = response.cart_count;

            eventBus.$emit('favorites-changed');
          }
        },


      }, // close methods
      created: function() {
        setTimeout(this.initCheckStatus, 500);
      }
  });


  // if (!$("#single-watch").length) {
    $.each($(".like-container"), function(index){
      // _log($(this).parents("#single-watch").length);
      if ($(this).parents("#single-watch").length === 0) {
        let element = $(this).attr("id");
        if (element) {
            new Vue({
            el: "#"+element,
            data: {},
            });
        }
      }
    });
  // }


} // close initComponentAddToCart

export { initCartElements };